<template>
    <div class="product-link">
        <h2 class="subtitle">Tags</h2>
        <div>
            <div v-if="productTags.length < 1">
                This product has no tags
                <br/>
            </div>
            <div v-for="tag in productTags">
                <router-link :to="{ name: 'tag', params: {id: tag.id}}">
                    {{ tag.name }}
                </router-link>
                <a class="delete" @click="remove(tag)"></a>
            </div>
        </div>
        <br/>
        <div v-if="!adding">
            <a class="button is-small" @click="adding = true">Add tag...</a>
        </div>
        <div v-if="adding">
            <p class="control">
                <span class="select">
                    <select name="tag-add" @change="add($event.target.value)">
                        <option>Select a tag...</option>
                        <option v-for="tag in availableTags" :value="tag.id">{{ tag.name }}</option>
                    </select>
                </span>
                <button type="button" class="button" @click="adding = false">Cancel</button>
            </p>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    import {CREATE_PRODUCT_TAG, DELETE_PRODUCT_TAG} from "../../store/mutation-types"
    export default {
        props: ['productId'],
        data() {
            return {
                adding: false,
            }
        },
        computed: Object.assign({}, mapGetters(['tags']), {
            availableTags () {
                let tags = this.$store.state.products.product_tags.filter(tag => tag.product_id === this.productId)
                let ids     = []
                for (let tag in tags) {
                    ids.push(tags[tag].tag_id)
                }
                return this.tags.filter(tag => ids.indexOf(tag.id) === -1).sort((a, b) => {
                    a       = a.name
                    b       = b.name
                    let reA = /[^a-zA-Z]/g;
                    let reN = /[^0-9]/g;
                    let aA  = a.replace(reA, "");
                    let bA  = b.replace(reA, "");
                    if (aA === bA) {
                        let aN = parseInt(a.replace(reN, ""), 10);
                        let bN = parseInt(b.replace(reN, ""), 10);
                        return aN === bN ? 0 : aN > bN ? 1 : -1;
                    } else {
                        return aA > bA ? 1 : -1;
                    }
                })
            },
            productTags () {
                let tags = this.$store.state.products.product_tags.filter(tag => tag.product_id === this.productId)
                let ids     = []
                for (let tag in tags) {
                    ids.push(tags[tag].tag_id)
                }
                return this.tags.filter(tag => ids.indexOf(tag.id) !== -1).map(tag => {
                    return Object.assign(tag, {
                        link_id: tags.find(c => c.tag_id === tag.id).id
                    })
                })
            }
        }),
        methods: {
            add(tag) {
                this.$store.dispatch(CREATE_PRODUCT_TAG, {
                    product_id: this.productId,
                    tag_id: tag
                })
                this.adding = false
            },
            remove(tag) {
                this.$store.dispatch(DELETE_PRODUCT_TAG, {
                    id: tag.link_id,
                    product_id: this.productId,
                    tag_id: tag.id,
                })
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ProductTags.vue?79444670